/* eslint-disable max-len */
import {useToast} from '@sttedra_ui/framework';

let lastNetworkErrorTime = 0;
const SUPPRESSION_INTERVAL = 5000; // 5 segundos
const toastService = useToast();

async function handleErrorCustom(err) {
  const now = Date.now();

  // Detectar fallo de red o timeout
  const isNetworkError = err.message === 'Network Error' || err.message.includes('timeout');

  if (isNetworkError) {
    // Si han pasado menos de 20 segundos desde el último error, no mostrar
    if (now - lastNetworkErrorTime < SUPPRESSION_INTERVAL) return;
    lastNetworkErrorTime = now;

    return toastService.add({
      type: 'danger',
      title: 'Operación errónea',
      message: 'Fallo de red',
      life: 15000,
      closable: true,
    });
  }

  if (err.response && err.response?.data instanceof Blob) {
    let mensaje = await err.response.data.text();
    if (typeof mensaje === 'string' && mensaje.trim().startsWith('{') && esObjetoOArrayJSON(mensaje)) {
      mensaje = JSON.parse(mensaje);
    }
    return toastService.add({
      type: 'danger',
      title: 'Operación errónea',
      message: mensaje.message ?? mensaje,
      life: 7000,
      closable: true,
    });
  } else {
    // Mostrar errores normales
    return toastService.add({
      type: 'danger',
      title: 'Operación errónea',
      message: err.response?.data?.message ?? err.message,
      life: 7000,
      closable: true,
    });
  }
}

async function handleError(message) {
  return toastService.add({
    type: 'danger',
    title: 'Operación errónea',
    message: message,
    life: 15000,
    closable: true,
  });
}

function esObjetoOArrayJSON(data) {
  try {
    const resultado = JSON.parse(data);
    return (typeof resultado === 'object' && resultado !== null);
  } catch (e) {
    return false;
  }
}


export {handleErrorCustom, handleError};
